module.exports = __webpack_public_path__ + "static/media/favicon.056ba4f1.ico";


//////////////////
// WEBPACK FOOTER
// ./src/navigation-bar/favicon.ico
// module id = 951
// module chunks = 0